/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as TimeLineLayerSpec } from '../../../../layer/preset/text/timeLine';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

type TimeLineLayerType = StandardChartLayerSpec & TimeLineLayerSpec & ILayerTypeSpec;

// 创建时间线图表数据类型验证器
const validateTimeLineDataTypes = createDataTypeValidator('timeLine', [
  { field: 'time', type: 'date' },
  { field: 'title', type: 'string' },
  { field: 'label', type: 'string' },
  { field: 'importance', type: 'number' },
  { field: 'url', type: 'string', required: false }
]);

// 创建时间线图表编码验证器
const validateTimeLineEncoding = createEncodingValidator([
  { field: 'time' },
  { field: 'title' },
  { field: 'label' },
  { field: 'importance' },
  { field: 'url', required: false }
]);

// 额外的检查函数 - 验证必填字段
const additionalTimeLineChecks = (layer: TimeLineLayerType) => {
  // 检查必填字段是否存在
  const { encoding } = layer;
  if (!encoding.time || !encoding.title || !encoding.label || !encoding.importance) {
    utils.logger.warn('warning', `Required fields missing for "${layer.type}" layer`);
    layer.__isEncodingValid = false;
  }
};

// 创建并导出时间线图表处理器
export const timeLine = createLayerProcessor<TimeLineLayerType>(
  'timeLine',
  validateTimeLineEncoding,
  validateTimeLineDataTypes,
  additionalTimeLineChecks
);
